import { useMemo } from "react";
import { useClinicalObservations } from "./useClinicalObservations";
import { toCanonicalTestResultFromObservation } from "../normalized-results";

/**
 * Read canonical results from the normalized observation resource. The
 * launch product intentionally does not hide a deprecated result source
 * behind this hook; callers should fix missing observation data at the API or
 * product-contract boundary instead.
 */
export function useCanonicalTestResults(opts?: {
  patientId?: string | null;
}) {
  const observationsQuery = useClinicalObservations(opts);

  const data = useMemo(() => {
    return observationsQuery.data?.map(toCanonicalTestResultFromObservation);
  }, [observationsQuery.data]);

  return {
    data,
    isLoading: observationsQuery.isLoading,
    isFetching: observationsQuery.isFetching,
    isError: observationsQuery.isError,
    error: observationsQuery.error ?? null,
    observationsQuery,
  };
}
